import AxiosInstance from "../Utils/axios/axiosConfig";

//Fetch the details of select paper machine
export const paperMachineListData = async (params) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_type) {
      const start = (params?.page - 1) * params?.size;
      const end = start + params?.size * 1;
      response = params.sort_by
        ? await AxiosInstance.get(
            `/machines/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
          )
        : await AxiosInstance.get(`/machines/?sort_by=id&sort_type=ascending`);
    } else if (params.status)
      response = await AxiosInstance.get(`/machines/?status=${params.status}`);
  } else response = await AxiosInstance.get(`/machines/`);

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const paperMachineListDataForConfiguration = async (params, source = undefined) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_type) {
      const start = (params?.page - 1) * params?.size;
      const end = start + params?.size * 1;
      response = params.sort_by
        ? await AxiosInstance.get(
            `/crud/machines/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
          )
        : await AxiosInstance.get(`/crud/machines/?sort_by=id&sort_type=ascending`);
    } else if (params.status)
      response = await AxiosInstance.get(`/crud/machines/?status=${params.status}`);
  } else{
    if(source){
      response = await AxiosInstance.get(`/crud/machines/`, {cancelToken: source?.token});
    } else{
      response = await AxiosInstance.get(`/crud/machines/`);
    }
  }

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

//form function
export const postPaperMachineList = async (body) => {
  const response = await AxiosInstance.post(
    "/jobcards/machine-selection/",
    body
  );
  // console.log("error res in post Machine list:", response);
  return response;
};

//Fetch machine details by code
export const fetchMachineDetails = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/machines/?get`, body);
  return response.data.data;
};

export const editMachine = async (code, body = {}) => {
  const response = await AxiosInstance.put(`/crud/machines/?code=${code}`, body);
  return response.data.data;
};

export const addMachine = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/machines/`, body);
  return response.data;
};

export const deleteMachine = async (code) => {
  const response = await AxiosInstance.delete(`/crud/machines/?code=${code}`);
  return response.data;
};

// Search machines
export const searchMachines = async (pattern = "", params = {}, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){
    response = await AxiosInstance.get("/crud/machines/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    if(source){
      response = await AxiosInstance.get("/crud/machines/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
        cancelToken: source?.token
      });
    } else{
    response = await AxiosInstance.get("/crud/machines/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        start: start,
        end: end,
      },
    });
  }
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredMachines = async (sortParams, filter, source = undefined, searchedValue) => {
  let response;

  // Build base URL
  let url = `/crud/machines/filter/`;

  // Add search params if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if available
  if (sortParams) {
    const start = (sortParams.page - 1) * sortParams.size;
    const end = start + sortParams.size;
    url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
  }

  // API call with optional cancel token
  if (source) {
    response = await AxiosInstance.post(url, filter, { cancelToken: source?.token });
  } else {
    response = await AxiosInstance.post(url, filter);
  }

  // Handle API response
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};



export const getRewinderRecords = async (params, source = undefined) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_type) {
      const start = (params?.page - 1) * params?.size;
      const end = start + params?.size * 1;
      response = params.sort_by ? await AxiosInstance.get(
            `/crud/rewinders/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
          )
        : await AxiosInstance.get(`/crud/rewinders/?sort_by=id&sort_type=ascending`);
    } else if (params.status)
      response = await AxiosInstance.get(`/crud/rewinders/?status=${params.status}`);
  } else{
    if(source){
      response = await AxiosInstance.get(`/crud/rewinders/`, {cancelToken: source?.token});
    } else{
      response = await AxiosInstance.get(`/crud/rewinders/`);
    }
  }

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const searchRewinders = async (pattern = "", params = {}, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){
    response = await AxiosInstance.get("/crud/rewinders/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    if(source){
      response = await AxiosInstance.get("/crud/rewinders/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
        cancelToken: source?.token
      });
    } else{
    response = await AxiosInstance.get("/crud/rewinders/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        start: start,
        end: end,
      },
    });
  }
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredRewinders = async (sortParams, filter, source = undefined, searchedValue) => {
  let response;

  // Build base URL
  let url = `/crud/rewinders/filter/`;

  // Add search params if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if available
  if (sortParams) {
    const start = (sortParams.page - 1) * sortParams.size;
    const end = start + sortParams.size;
    url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
  }

  // API call with optional cancel token
  if (source) {
    response = await AxiosInstance.post(url, filter, { cancelToken: source?.token });
  } else {
    response = await AxiosInstance.post(url, filter);
  }

  // Handle API response
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getRewindersByMachineCode = async (code) => {
  let response;
  response = await AxiosInstance.get(`crud/rewinders/?machine=${code}`);

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getCuttersRecords = async (params, source = undefined) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_type) {
      const start = (params?.page - 1) * params?.size;
      const end = start + params?.size * 1;
      response = params.sort_by ? await AxiosInstance.get(
            `/crud/cutters/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
          )
        : await AxiosInstance.get(`/crud/cutters/?sort_by=id&sort_type=ascending`);
    } else if (params.status)
      response = await AxiosInstance.get(`/crud/cutters/?status=${params.status}`);
  } else{
    if(source){
      response = await AxiosInstance.get(`/crud/cutters/`, {cancelToken: source?.token});
    } else{
      response = await AxiosInstance.get(`/crud/cutters/`);
    }
  }

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const searchCutters = async (pattern = "", params = {}, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){
    response = await AxiosInstance.get("/crud/cutters/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    if(source){
      response = await AxiosInstance.get("/crud/cutters/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
        cancelToken: source?.token
      });
    } else{
    response = await AxiosInstance.get("/crud/cutters/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        start: start,
        end: end,
      },
    });
  }
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredCutters = async (sortParams, filter, source = undefined, searchedValue) => {
  let response;

  // Build base URL
  let url = `/crud/cutters/filter/`;

  // Add search params if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if available
  if (sortParams) {
    const start = (sortParams.page - 1) * sortParams.size;
    const end = start + sortParams.size;

    url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
  }

  // API call with optional cancel token
  if (source) {
    response = await AxiosInstance.post(url, filter, { cancelToken: source?.token });
  } else {
    response = await AxiosInstance.post(url, filter);
  }

  // Handle API response
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

  
export const getCuttersByMachineCode = async (code) => {
    let response;
    response = await AxiosInstance.get(`crud/cutters/?machine=${code}`);
  
    if (!response.data.error) {
      return response.data.data;
    } else {
      return Promise.reject(response);
    }
};

export const addRewinder = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/rewinders/`, body);
  return response.data;
};

export const getRewinderByCode = async (code = "") => {
  const response = await AxiosInstance.get(`/crud/rewinders/?code=${code}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getDeckleMachineOrders = async (body,sort_by = "updated_at",sort_type="ascending",start=0,end=10,type='selected_orders',source=undefined) => {
  let response;
  if (source) {
    response = await AxiosInstance.post(
      `/jobcards/orders-selection/?sort_by=${sort_by}&sort_type=${sort_type}&start=${start}&end=${end}&order_type=${type}`,
      body,
      { cancelToken: source.token }
    );
  } else {
    response = await AxiosInstance.post(
      `/jobcards/orders-selection/?sort_by=${sort_by}&sort_type=${sort_type}&start=${start}&end=${end}&order_type=${type}`,
      body
    );
  }
    
  // console.log("error res in post Machine list:", response);
  return response;
};

export const getDeckleMachineOrdersForMultiStage = async (body,sort_by = "updated_at",sort_type="ascending",start=0,end=10,type='selected_orders',source = undefined) => {
  let response;
  if (source) {
    response =
   await AxiosInstance.post(
    `/jobcards/multistage/orders-selection/?sort_by=${sort_by}&sort_type=${sort_type}&start=${start}&end=${end}&order_type=${type}`,
    body,
    { cancelToken: source.token }
  );
}
else
{
  response =
  await AxiosInstance.post(
   `/jobcards/multistage/orders-selection/?sort_by=${sort_by}&sort_type=${sort_type}&start=${start}&end=${end}&order_type=${type}`,
   body
  );
}
  // console.log("error res in post Machine list:", response);
  return response;
};

export const machineSelectedOrders = async (body) => {
  const response = await AxiosInstance.post(
    `/jobcards/machine-selection/orders/`,
    body
  );
  return response.data;
};

export const machineSelectedOrdersMultiStage = async (body) => {
  const response = await AxiosInstance.post(
    `/jobcards/multistage/machine-selection/orders/`,
    body
  );
  return response.data;
};

export const searchDeckleMachineOrders = async (machineCode, pattern,req,params) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  const response = await AxiosInstance.post(`jobcards/orders-selection/?search&machine_code=${machineCode}&type=contains&pattern=${pattern}&start=${start}&end=${end}`,req);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
}

export const getFilteredMachineOrders = async (
  filter,
  params,
  sortParams,
  machineCode,
  state,
  priority,
  type,
  source = undefined
) => {
  let response;
  
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    let tempFilter = filter;

    if (state)
      tempFilter = tempFilter.concat({ type: "status", status: state });

    if (priority) tempFilter = tempFilter.concat({ type: "priority" });

    response = await AxiosInstance.post(
      `/orders/filter/?machine_orders&machine_code=${machineCode}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}&type=${type}`,
      tempFilter
    );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const searchDeckleMachineOrdersForMultiStage = async (orderType, pattern,req,params) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  const response = await AxiosInstance.post(`jobcards/multistage/orders-selection/?search&order_type=${orderType}&type=contains&pattern=${pattern}&start=${start}&end=${end}&flow_type=po`,req);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
}

export const getFilteredMachineOrdersForMultiStage = async (
  filter,
  params,
  sortParams,
  machineCode,
  state,
  priority,
  type,
  source = undefined
) => {
  let response;
  
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    let tempFilter = filter;

    if (state)
      tempFilter = tempFilter.concat({ type: "status", status: state });

    if (priority) tempFilter = tempFilter.concat({ type: "priority" });

    response = await AxiosInstance.post(
      `/orders/filter/?multistage_machine_orders&sort_type=${sortParams.sort_type}&start=${start}&end=${end}&type=${type}`,
      tempFilter
    );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const updateRewinderByCode = async (code = "",body) => {
  const response = await AxiosInstance.put(`/crud/rewinders/?code=${code}`,body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteRewinderByCode = async (code = "") => {
  const response = await AxiosInstance.delete(`/crud/rewinders/?code=${code}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getAllRewinder = async () => {
  const response = await AxiosInstance.get(`/crud/rewinders/`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getCuttersByCode = async (code = "") => {
  const response = await AxiosInstance.get(`/crud/cutters/?code=${code}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getAllCutter = async () => {
  const response = await AxiosInstance.get(`/crud/cutters/`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const addCutter = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/cutters/`, body);
  return response.data;
};

export const updateCutterByCode = async (code = "",body) => {
  const response = await AxiosInstance.put(`/crud/cutters/?code=${code}`,body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteCutterByCode = async (code = "") => {
  const response = await AxiosInstance.delete(`/crud/cutters/?code=${code}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};